// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"d6d14bf0","572":"ca858378"}[chunkId] + ".css";
};